"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const insights_1 = require("../insights");
const danger = '#d70b0b';
exports.theme = extendTheme_1.extendTheme(insights_1.theme, {
    name: 'barbie',
    userFriendlyName: 'Barbie',
    dark: true,
    colors: {
        primary: '#ed5c9b',
        primaryText: '#fff',
        primaryDark: '#e0218a',
        danger,
        muted: '#ccc',
        success: '#87c144',
        accent: '#ee0',
        selected: '#ee0',
        online: '#87c144',
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        accentBackgroundedText: '#111',
        pageBackground: '#f6f6f6',
        cardBackground: '#fff',
        offline: danger,
        cardText: '#000',
        floorplans: {
            area: {
                background: '#ee0',
            },
        },
        charts: {
            primary: '#f031aa',
            min: '#0000ff',
            max: '#ff0000',
            neutral: '#bbbbbb',
            intervalShade: '#ddd',
        },
    },
});
//# sourceMappingURL=index.js.map